/**
 * Role Configuration - Paliacate OS
 * ==================================
 * Define los 6 roles del sistema y sus permisos en el frontend.
 * 
 * Roles:
 *   1. admin       - Acceso total
 *   2. supervisor  - Ve todo excepto finanzas y config
 *   3. ventas      - Ciclo comercial completo
 *   4. disenador   - Solo sus proyectos creativos
 *   5. produccion  - Solo sus tareas de producción
 *   6. cliente     - Solo su propia información
 */

// ============================================================
// PÁGINAS DEL ADMIN PANEL POR ROL
// ============================================================

export const ADMIN_PAGES = {
  admin: [
    'dashboard', 'executive', 'supervisor', 'ceo', 'iso9001',
    'pipeline', 'crm', 'leads', 'sales-dashboard', 'billing',
    'petty-cash', 'emails', 'attendance', 'production',
    'analytics', 'workers', 'users', 'interactions',
    'reports', 'portfolio', 'config', 'team',
    'drive-monitor', 'email-mappings', 'email-lifecycle',
    'service-catalog', 'proposals-dashboard', 'templates',
    'pipeline-auto', 'site-editor',
  ],

  supervisor: [
    'dashboard', 'supervisor', 'pipeline', 'crm', 'leads',
    'production', 'workers', 'interactions', 'reports',
    'attendance', 'team', 'analytics', 'calendar',
  ],

  ventas: [
    'sales-dashboard', 'pipeline', 'crm', 'leads', 'sales-pipeline',
    'billing', 'petty-cash', 'email-lifecycle',
    'interactions', 'service-catalog', 'proposals-dashboard',
    'chat', 'content-calendar',
  ],
};

// ============================================================
// CONFIGURACIÓN DE ROLES
// ============================================================

export const ROLE_CONFIG = {
  admin: {
    label: 'Administrador',
    color: 'red',
    homePath: '/admin',
    portal: 'admin',
  },
  supervisor: {
    label: 'Supervisor',
    color: 'blue',
    homePath: '/admin/supervisor',
    portal: 'admin',
  },
  ventas: {
    label: 'Ventas',
    color: 'orange',
    homePath: '/admin/sales-dashboard',
    portal: 'admin',
  },
  disenador: {
    label: 'Diseñador',
    color: 'purple',
    homePath: '/worker/dashboard',
    portal: 'worker',
  },
  produccion: {
    label: 'Producción',
    color: 'green',
    homePath: '/worker/dashboard',
    portal: 'worker',
  },
  cliente: {
    label: 'Cliente',
    color: 'teal',
    homePath: '/portal/dashboard',
    portal: 'portal',
  },
};

// ============================================================
// HELPER FUNCTIONS
// ============================================================

/**
 * Check if a system_role can access a specific admin page
 */
export function canAccessPage(systemRole, pageId) {
  if (!systemRole || systemRole === 'admin') return true;
  const pages = ADMIN_PAGES[systemRole];
  if (!pages) return false;
  return pages.includes(pageId);
}

/**
 * Get the role config for a system_role
 */
export function getRoleConfig(systemRole) {
  return ROLE_CONFIG[systemRole] || ROLE_CONFIG.admin;
}

/**
 * Get allowed admin pages for a role
 */
export function getAllowedPages(systemRole) {
  if (!systemRole || systemRole === 'admin') return ADMIN_PAGES.admin;
  return ADMIN_PAGES[systemRole] || [];
}

/**
 * Get the system_role from localStorage
 */
export function getCurrentSystemRole() {
  try {
    const user = JSON.parse(localStorage.getItem('portal_user') || '{}');
    return user.system_role || 'admin';
  } catch {
    return 'admin';
  }
}
